import { createSlice } from "@reduxjs/toolkit";

const titleSlice = createSlice({
  name: "title",
  initialState: {
    title: "",
  },

  reducers: {
    setTitle: (state, action) => {
      state.title = action.payload;
    },
  },
});

export const setTitle = titleSlice.actions.setTitle;
export default titleSlice.reducer;
